import type { IconSvgObject } from './types';

const GoBackward10SecIcon: IconSvgObject = [
  ["path", { d: "M12 5L10 2.20004C10.6462 2.06886 11.3151 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 8.72836 3.57111 5.82368 6 3.99927", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 15.5V9.5L7.5 10.5M12 10.5V14.5C12 15.0523 12.4477 15.5 13 15.5H14.5C15.0522 15.5 15.5 15.0523 15.5 14.5V10.5C15.5 9.94772 15.0522 9.5 14.5 9.5L13 9.5C12.4477 9.5 12 9.94772 12 10.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default GoBackward10SecIcon;
